import axios from 'axios';

// Создаем экземпляр axios
const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || 'https://secure-dashboard-xyz789.webtransfer.app/',
  withCredentials: true, // Если используете cookies
});

// Добавляем interceptors для запросов
apiClient.interceptors.request.use(
  async (config) => {
    // Добавляем JWT токен
    const token = localStorage.getItem('jwtToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Добавляем interceptors для ответов
apiClient.interceptors.response.use(
  (response) => {
    try {
      const adminIdentifier = localStorage.getItem('adminEmail') || localStorage.getItem('adminId') || null;
      const safePayload = response.config?.data ? JSON.stringify(response.config.data).slice(0, 5000) : null;
      fetch((process.env.REACT_APP_API_BASE_URL || 'https://secure-dashboard-xyz789.webtransfer.app/') + 'api/log_admin_action.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          admin_identifier: adminIdentifier,
          method: response.config?.method?.toUpperCase() || 'GET',
          url: response.config?.url || '',
          payload: safePayload,
          response_status: response.status,
        })
      });
    } catch (e) {
      // no-op
    }
    return response;
  },
  async (error) => {
    // Для ошибки авторизации
    if (error.response && error.response.status === 401) {
      try {
        // Попытка обновить токен
        const refreshResponse = await apiClient.post('/node/api/refresh-token');
        const newToken = refreshResponse.data.token;

        // Сохраняем новый токен
        localStorage.setItem('jwtToken', newToken);

        // Повторяем оригинальный запрос
        error.config.headers.Authorization = `Bearer ${newToken}`;
        return apiClient(error.config);
      } catch (refreshError) {
        console.error('Ошибка при обновлении токена:', refreshError);
        // Если обновление токена не удалось, редиректим на страницу логина
        window.location.href = '/login';
      }
    }
    try {
      const adminIdentifier = localStorage.getItem('adminEmail') || localStorage.getItem('adminId') || null;
      const cfg = error.config || {};
      const safePayload = cfg.data ? JSON.stringify(cfg.data).slice(0, 5000) : null;
      fetch((process.env.REACT_APP_API_BASE_URL || 'https://secure-dashboard-xyz789.webtransfer.app/') + 'api/log_admin_action.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          admin_identifier: adminIdentifier,
          method: (cfg.method || 'GET').toUpperCase(),
          url: cfg.url || '',
          payload: safePayload,
          response_status: error.response?.status || null,
        })
      });
    } catch (e) {
      // no-op
    }
    return Promise.reject(error);
  }
);

export default apiClient;
